import { breakpoints, colors, pxToRem } from '@vfit/shared/themes';
import styled, { css } from 'styled-components';
import { OfferFrameForStyled } from './offerFrame.models';

const variants = {
  sunrise: css`
    border: 1px solid ${colors.$bebebe};
    border-radius: ${pxToRem(20)};
    padding: ${pxToRem(32, 24)};
    gap: ${pxToRem(32)};
    width: 100%;

    @media (min-width: ${breakpoints.tablet}) {
      width: ${pxToRem(327)};
    }

    @media (min-width: ${breakpoints.desktop}) {
      width: ${pxToRem(405)};
    }

    hr {
      background-color: ${colors.$bebebe};
    }

    p:last-child {
      margin-bottom: 0;
    }
  `,
  mva: css`
    border: none;
    border-radius: ${pxToRem(6)};
    padding: ${pxToRem(20, 16)};
    gap: ${pxToRem(24)};
    box-shadow: 0 2px 8px rgb(0 0 0 / 0.16);
    background-color: ${colors.$ffffff};
    width: 100%;

    @media (min-width: ${breakpoints.tablet}) {
      padding: ${pxToRem(24, 16)};
      gap: ${pxToRem(28)};
    }

    @media (min-width: ${breakpoints.desktop}) {
      padding: ${pxToRem(32, 16)};
      gap: ${pxToRem(32)};
    }

    hr {
      background-color: ${colors.$f2f2f2};
    }
  `,
};

export const Container = styled.div<OfferFrameForStyled>`
  display: flex;
  flex-direction: column;
  height: fit-content;

  hr {
    height: ${pxToRem(1)};
    border: none;
    width: 100%;
    margin: 0 auto;

    &:nth-last-child(2), &:last-child{
      display: none;
    }
  }

  ${({ variant }) => variants[variant || 'sunrise']}
`;